import { useMemo } from "react";

import { useFindManyCarriersSmc3Query } from "api/rest/smc3/findManyCarriersSmc3";
import Loading from "components/Loading";
import withAsync from "components/withAsync";

import { usePartnersSliceSelector } from "../store/partnersStore";
import { useSetState } from "../store/smc3IntegrationsSlice";
import CarrierTileView, { CarrierTileViewProps } from "../views/CarrierTileView";
import CarrierIntegrationDialogContainer from "./CarrierIntegrationDialogContainer";

const CarrierIntegrationsIndexContainer = withAsync({
  useHook: () => {
    const search = usePartnersSliceSelector((store) => store.smc3IntegrationsSlice.search);

    const result = useFindManyCarriersSmc3Query({
      queryParams: { allowsContractPricing: true, allowsDispatch: true, search },
    });

    return result;
  },
  LoadingComponent: <Loading spinnerOnly height="80vh" />,
  Component: ({ loadedData }) => {
    const setState = useSetState();
    const dataResult = useMemo(() => {
      return (loadedData.data?.data ?? []).map(
        (carrier): CarrierTileViewProps => ({
          connected: !!carrier.smc3CarrierShipper,
          name: carrier.carrier.name,
          scac: carrier.carrier.scac,
          onClick: () => {
            setState({
              selectedCarrier: carrier,
              dialogOpen: true,
              billToAddressId: carrier.smc3CarrierShipper?.bill_to_address?.id,
              billToAccountNumber: carrier.smc3CarrierShipper?.bill_to_account ?? undefined,
              billingName: carrier.smc3CarrierShipper?.bill_to_name ?? undefined,
              paymentCurrency: carrier.smc3CarrierShipper?.payment_currency,
              paymentPayer: carrier.smc3CarrierShipper?.payment_payer,
              paymentTerms: carrier.smc3CarrierShipper?.payment_terms,
              email: carrier.smc3CarrierShipper?.contact?.user?.email ?? undefined,
              firstName: carrier.smc3CarrierShipper?.contact?.first_name ?? undefined,
              lastName: carrier.smc3CarrierShipper?.contact?.last_name ?? undefined,
              isCreated: !!carrier.smc3CarrierShipper,
            });
          },
        })
      );
    }, [loadedData, setState]);

    return (
      <>
        <div className="p-2 flex flex-wrap gap-2 justify-center">
          {dataResult.map((carrierTileProps, i) => (
            <CarrierTileView key={i} {...carrierTileProps} />
          ))}
        </div>

        <CarrierIntegrationDialogContainer />
      </>
    );
  },
});

export default CarrierIntegrationsIndexContainer;
